import { render, staticRenderFns } from "./EditContact.vue?vue&type=template&id=27e1b450&"
import script from "./EditContact.js?vue&type=script&lang=js&"
export * from "./EditContact.js?vue&type=script&lang=js&"
import style0 from "./EditContact.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports